import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Routes a company_owner can access even without an active subscription
const BILLING_FREE_PATHS = ["/billing", "/billing/return", "/onboarding"];

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [billingChecked, setBillingChecked] = useState(false);
  const [billingActive, setBillingActive] = useState(true);

  useEffect(() => {
    if (!user || user === false) { setBillingChecked(true); return; }
    if (user.role !== "company_owner") { setBillingChecked(true); setBillingActive(true); return; }
    api.get("/billing/me").then(({ data }) => {
      const s = data?.subscription?.status;
      // Allow "free_claimed" (came in via cold-outreach invite) full portal access.
      // They're gently nudged with the upgrade banner; only the public quote URL stays offline.
      setBillingActive(s === "active" || s === "trialing" || s === "free_claimed");
    }).catch(() => setBillingActive(false))
      .finally(() => setBillingChecked(true));
  }, [user]);

  if (loading || user === null || !billingChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;

  if (user.role === "company_owner" && !billingActive) {
    const onAllowedPath = BILLING_FREE_PATHS.some((p) => location.pathname.startsWith(p));
    if (!onAllowedPath) return <Navigate to="/billing" replace />;
  }

  return children;
}
